import { campaignOccurrenceTypes } from '../../views/Campaign/constants';
import { ProductType } from 'constants.js';

const isProductSupported = (product, settings) => {
  return (
    settings?.integratingProducts.indexOf(product) > -1 &&
    !product.internalProduct
  );
};
function getEventEntitySchema(eventEntity) {
  return eventEntity.eventTypes.length
    ? eventEntity.eventTypes[0].schemaId
    : '';
}
const isProductAdded = (options, id) => {
  let option = options.find((optionObj) => optionObj.id === id);
  return !!option?.id;
};

const hasTransientEventTypes = (eventEntities) => {
  return (
    eventEntities.filter((event) => event.longTermStorage || event.internal)
      .length > 0
  );
};

const hasExternalTransientEventTypes = (eventEntities) => {
  return eventEntities.filter((event) => event.longTermStorage).length > 0;
};

const createSupportedEventTypeOptionsForAllCampaignTypes = (
  supportedEventTypes,
  settings,
  campaignOccurrenceType,
  allowBoth,
  allowInternalProducts
) => {
  let eventTypeOptions = [];
  let canAllowBoth = allowBoth || false;

  supportedEventTypes.productCategories.forEach((category) => {
    category.productNames.forEach((product) => {
      if (
        !isProductSupported(
          `${category.productCategory}:${product.productName}`,
          settings
        )
      ) {
        return;
      }
      product.eventEntities.forEach((eventEntity, _index) => {
        if (
          ((campaignOccurrenceType ===
            campaignOccurrenceTypes.INTERNAL_SURVEY_RESPONSE ||
            campaignOccurrenceType ===
              campaignOccurrenceTypes.EXTERNAL_SURVEY_RESPONSE ||
            campaignOccurrenceType === campaignOccurrenceTypes.SCHEDULED ||
            campaignOccurrenceType === campaignOccurrenceTypes.ON_DEMAND) &&
            !canAllowBoth &&
            eventEntity.longTermStorage === false) ||
          (eventEntity.internal && !allowInternalProducts)
        ) {
          return;
        }

        if (
          eventEntity.eventTypes.length > 0 &&
          !isProductAdded(
            eventTypeOptions,
            `${category.productCategory}.${product.productName}`
          )
        ) {
          let productOptions = [
            {
              id: category.productCategory,
              type: 'PRODUCT_CATEGORY',
              displayName: category.productCategory
            },
            {
              id: `${category.productCategory}.${product.productName}`,
              type: 'PRODUCT_NAME',
              displayName: product.productName
            }
          ];

          eventTypeOptions = [...eventTypeOptions, ...productOptions];
        }

        let eventTypeCategoryoption = [
          {
            id: `${category.productCategory}.${product.productName}.${eventEntity.eventTypeCategory}`,
            type: 'EVENT_TYPE_CATEGORY',
            displayName: eventEntity.eventTypeCategory,
            schemaIdentifier: `${category.productCategory}.${product.productName}.${eventEntity.eventTypeCategory}`,
            productCategory: category.productCategory,
            productName: product.productName,
            eventTypeCategory: eventEntity.eventTypeCategory,
            longTermStorage: eventEntity.longTermStorage,
            schemaId: getEventEntitySchema(eventEntity),
            partialCollectionName:
              eventEntity.schemaToEventPartialCollectionName
          }
        ];

        eventTypeOptions = [...eventTypeOptions, ...eventTypeCategoryoption];

        if (campaignOccurrenceType === campaignOccurrenceTypes.ON_EVENT) {
          eventEntity.eventTypes.forEach((eventType) => {
            let eventOption = {
              id: `${category.productCategory}.${product.productName}.${eventEntity.eventTypeCategory}.${eventType.eventType}`,
              type: 'EVENT_TYPE',
              displayName: eventType.eventType,
              schemaIdentifier: `${category.productCategory}.${product.productName}.${eventEntity.eventTypeCategory}.${eventType.eventType}`,
              productCategory: category.productCategory,
              productName: product.productName,
              eventTypeCategory: eventEntity.eventTypeCategory,
              longTermStorage: eventEntity.longTermStorage,
              partialCollectionName:
                eventEntity.schemaToEventPartialCollectionName,
              ...eventType
            };

            eventTypeOptions = [...eventTypeOptions, eventOption];
          });
        }
      });
    });
  });

  return eventTypeOptions;
};

const getProductList = (supportedEventTypes, settings) => {
  let integratingProducts = [];
  let transientProductCategories = [];
  let transientProductNames = [];
  let externalTransientProductCategories = [];
  let externalTransientProductNames = [];
  let externalProductCategories = [];
  let externalProductNames = [];
  supportedEventTypes.productCategories.map((category) => {
    category.productNames
      .filter((name) => !name.internalProduct)
      .map((name) => {
        integratingProducts.push(
          `${category.productCategory}:${name.productName}`
        );
      });
    category.productNames
      .filter(
        (name) =>
          hasTransientEventTypes(name.eventEntities) &&
          isProductSupported(
            `${category.productCategory}:${name.productName}`,
            settings
          )
      )
      .map((name) => {
        transientProductCategories.push(category.productCategory);
        transientProductNames.push(name.productName);
      });
    category.productNames
      .filter(
        (name) =>
          hasExternalTransientEventTypes(name.eventEntities) &&
          isProductSupported(
            `${category.productCategory}:${name.productName}`,
            settings
          )
      )
      .map((name) => {
        externalTransientProductCategories.push(category.productCategory);
        externalTransientProductNames.push(name.productName);
      });
    category.productNames
      .filter(
        (name) =>
          isProductSupported(
            `${category.productCategory}:${name.productName}`,
            settings
          ) && !name.internalProduct
      )
      .map((name) => {
        externalProductCategories.push(category.productCategory);
        externalProductNames.push(name.productName);
      });
  });
  transientProductCategories = [...new Set(transientProductCategories)];
  externalTransientProductCategories = [
    ...new Set(externalTransientProductCategories)
  ];
  externalProductCategories = [...new Set(externalProductCategories)];
  return {
    integratingProducts,
    transientProductCategories,
    transientProductNames,
    externalTransientProductCategories,
    externalTransientProductNames,
    externalProductCategories,
    externalProductNames
  };
};

const getIntegrations = (supportedIntegrations) => {
  let productCategories = [];
  let productNames = [];
  supportedIntegrations.map((category) => {
    let [productCategory, productName] = category.replace(/"/g, '').split(':');
    productCategories.push(productCategory);
    productNames.push(productName);
  });
  productCategories = [...new Set(productCategories)];
  return { productCategories, productNames };
};

export const createSupportedEventTypeOptions = (
  supportedEventTypes,
  settings
) => {
  let eventOptions = createSupportedEventTypeOptionsForAllCampaignTypes(
    supportedEventTypes,
    settings,
    campaignOccurrenceTypes.ON_EVENT
  );
  let productIntegrationOptions =
    createSupportedEventTypeOptionsForAllCampaignTypes(
      supportedEventTypes,
      settings,
      campaignOccurrenceTypes.SCHEDULED
    );
  let scheduledOptions = createSupportedEventTypeOptionsForAllCampaignTypes(
    supportedEventTypes,
    settings,
    campaignOccurrenceTypes.SCHEDULED
  );
  let onDemandOptions = createSupportedEventTypeOptionsForAllCampaignTypes(
    supportedEventTypes,
    settings,
    campaignOccurrenceTypes.ON_DEMAND
  );
  let internalSurveyResponseOptions =
    createSupportedEventTypeOptionsForAllCampaignTypes(
      supportedEventTypes,
      settings,
      campaignOccurrenceTypes.INTERNAL_SURVEY_RESPONSE
    );
  let externalSurveyResponseOptions =
    createSupportedEventTypeOptionsForAllCampaignTypes(
      supportedEventTypes,
      settings,
      campaignOccurrenceTypes.EXTERNAL_SURVEY_RESPONSE
    );
  let printOptions = createSupportedEventTypeOptionsForAllCampaignTypes(
    supportedEventTypes,
    settings,
    campaignOccurrenceTypes.SCHEDULED,
    true
  );
  let allEventTypeCategoryOptions =
    createSupportedEventTypeOptionsForAllCampaignTypes(
      supportedEventTypes,
      settings,
      campaignOccurrenceTypes.ON_DEMAND,
      true
    );
  let allEventOptions = createSupportedEventTypeOptionsForAllCampaignTypes(
    supportedEventTypes,
    settings,
    campaignOccurrenceTypes.ON_DEMAND,
    true,
    true
  );
  let availableIntegrations = getIntegrations(settings.integratingProducts);
  let {
    integratingProducts,
    transientProductCategories,
    transientProductNames,
    externalTransientProductCategories,
    externalTransientProductNames,
    externalProductCategories,
    externalProductNames
  } = getProductList(supportedEventTypes, settings);

  scheduledOptions = scheduledOptions.map((option) => {
    if (option.type !== 'EVENT_TYPE_CATEGORY') {
      return option;
    }

    return {
      schemaId: 'static_scheduled',
      isStaticType: false,
      id: option.id + '.scheduled',
      ...option
    };
  });

  onDemandOptions = onDemandOptions.map((option) => {
    if (option.type !== 'EVENT_TYPE_CATEGORY') {
      return option;
    }
    return {
      schemaId: 'static_onDemand',
      isStaticType: false,
      id: option.id + '.onDemand',
      ...option
    };
  });

  return {
    eventOptions,
    productIntegrationOptions,
    scheduledOptions,
    onDemandOptions,
    internalSurveyResponseOptions,
    externalSurveyResponseOptions,
    printOptions,
    integratingProducts,
    availableIntegrations,
    transientProductCategories,
    transientProductNames,
    externalTransientProductCategories,
    externalTransientProductNames,
    allEventTypeCategoryOptions,
    allEventOptions,
    externalProductCategories,
    externalProductNames
  };
};

export const getMetaDataPathInfo = (options) => {
  const {
    schemaIdentifier,
    supportedEventTypesOptions,
    supportedScheduledTypes,
    supportedOnDemandTypes,
    supportedInternalSurveyResponseTypes,
    workflow,
    campaignOccurrenceType,
    productName,
    productType,
    eventOptions
  } = options;

  let eventTypeInfo;

  if (
    productType === ProductType.List ||
    productType === ProductType.GUEST_INSIGHTS
  ) {
    eventTypeInfo = eventOptions.find(
      (option) => option.id === schemaIdentifier
    );
  } else if (campaignOccurrenceType === 'SCHEDULED') {
    eventTypeInfo = supportedScheduledTypes.find(
      (option) => option.id === schemaIdentifier
    );
  } else if (campaignOccurrenceType === 'ON_DEMAND') {
    eventTypeInfo = supportedOnDemandTypes.find(
      (option) => option.id === schemaIdentifier
    );
  } else if (campaignOccurrenceType === 'INTERNAL_SURVEY_RESPONSE') {
    eventTypeInfo = supportedInternalSurveyResponseTypes.find(
      (option) => option.id === schemaIdentifier
    );
  } else {
    eventTypeInfo = supportedEventTypesOptions.find(
      (option) => option.id === schemaIdentifier
    );
  }

  const { productCategory, eventTypeCategory, eventType } = eventTypeInfo;

  let metaDataPathInfo = {
    metaDataPath: [
      productCategory,
      productName,
      eventTypeCategory,
      eventType,
      workflow
    ],
    isStaticType: eventTypeInfo.isStaticType
  };

  return metaDataPathInfo;
};
